import { Divider, Text } from '@farmersdog/corgi-x';

import styles from '../RecipesSelection.module.css';

interface PriceDividerProps {
  text: string;
}

export const PriceDivider = ({ text }: PriceDividerProps) => (
  <div className={styles.priceWrapper}>
    <Text bold variant="heading-16" className={styles.priceText}>
      {text}
    </Text>
    <div className={styles.priceDivider}>
      <Divider width={4} spacing={11} color="Charcoal0" borderStyle="dotted" />
    </div>
  </div>
);
